import { render } from "./navigations-leiste.vue?vue&type=template&id=6616cab6&scoped=true"
import script from "./navigations-leiste.vue?vue&type=script&lang=js"
export * from "./navigations-leiste.vue?vue&type=script&lang=js"

import "./navigations-leiste.vue?vue&type=style&index=0&id=6616cab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6616cab6"]])

export default __exports__